import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { ServiceDeleteBase } from "../../../shared/services/base/ServiceDeleteBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { NucleoService } from "./NucleoService";

/** Baja de núcleos; la saca del listado en memoria. */
export class NucleoDeleteService extends ServiceDeleteBase {
  protected readonly cache = NucleoService.instance;

  /** gRPC-Web (`EliminarNucleo`): baja lógica. */
  protected async sendDelete(id: string): Promise<void> {
    await grpcCall(() => grpcClient(ProyectosPlataformaService).eliminarNucleo({ id }));
  }
}
